export default function Logo({ className = "" }) {
    return (
        <span className={`inline-flex items-center ${className}`} data-testid="edit-logo">
            <img src="/edit-logo.png" alt="edit." className="h-5 w-auto" />
        </span>
    );
}
